import type React from 'react';
import { ProductDraftsNoticeView } from './ProductDraftsNoticeView';
import { useProductDraftCount } from './useProductDraftCount';
import type { ProductDraftsNoticeProps } from './productDraftsNoticeTypes';

type ProductDraftsNoticeContentProps = ProductDraftsNoticeProps;

/** Reads the draft count and hands its state to the View (rulebook §5.2). */
export const ProductDraftsNoticeContent: React.FC<
    ProductDraftsNoticeContentProps
> = ({ isDraftsOnly, onShowDrafts }) => {
    const state = useProductDraftCount();
    return (
        <ProductDraftsNoticeView
            isDraftsOnly={isDraftsOnly}
            onShowDrafts={onShowDrafts}
            state={state}
        />
    );
};
